<template>
  <div id="app">
    <router-view/>                                             
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>.dataBox{
  background-color: #fff;
  margin:  15px 5px;
  padding:45px 34px 26px;
}
.top-row {
  box-sizing: border-box;
  padding: 20px;
}
.label-box {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue